import { Config } from '@cigna/pdl-viewer/shared/util';

export const pdlEnvironment: Config = {
  production: false,
  hmr: false,

  oidc: {
    secureUris: [
      'https://static.cigna.com',
      'https://static.cigna.com',
      'https://p-digital.digitaledge.cigna.com',
      'https://p-chcp.digitaledge.cigna.com',
    ],
  },

  contentBundle: {
    manifestFilename: 'content/pdl/manifest.json?v=8',
    resolvePageContentTimeoutSeconds: 10,
  },

  sessionTimeoutPopup: {
    timeoutDuration: 10,
    logoutDuration: 5,
    keepAliveUrl: '/mycignatheme/images/blank.gif',
  },

  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://p-digital-static.digitaledge.cigna.com/',
      resourceContent: 'https://static.cigna.com/',
      drugsearch: 'https://p-chcp.digitaledge.cigna.com',
      gsg: 'https://p-gsg.digitaledge.cigna.com',
      drugSearchPublic: 'https://p-digital.digitaledge.cigna.com',
    },
  },
};
